import { useEffect, useRef } from 'react';

import { useTranslation } from 'react-i18next';

import { useDialog } from '@shared/hooks';
import { closeBanner } from '@widgets/ConversationBanner/api/closeBanner';

export const useConversationBanner = () => {
    const { t } = useTranslation();
    const ref = useRef<HTMLDivElement>(null);

    const { close, isOpen, open } = useDialog();
    const {
        close: hideBanner,
        isOpen: isOpenBanner,
        open: openBanner,
        // @ts-ignore
    } = useDialog(Array.isArray(modalData) && !Array.isArray(bannerData));

    const closeClientModal = () => {
        close();
        openBanner();
    };

    const onSendSurvey = async () => {
        // @ts-ignore
        await closeBanner(modalData.id);
        // @ts-ignore
        bannerData = [];
        // @ts-ignore
        modalData = [];
        close();
    };

    // useEffect(() => {
    //     // @ts-ignore
    //     if (!Array.isArray(modalData)) {
    //         open();
    //     }
    //
    //     const estimateNav = document.querySelector('.estimate-nav');
    //     const contentWrapper = document.querySelector('.content-wrapper');
    //     const TeamTrialBanner = document.querySelector('#TeamTrialBanner');
    //
    //     // @ts-ignore
    //     if (Array.isArray(modalData) && !Array.isArray(bannerData)) {
    //         // @ts-ignore
    //         contentWrapper.style.paddingTop = `${60 + (TeamTrialBanner ? 44 : 0)}px`;
    //
    //         if (TeamTrialBanner) {
    //             if (!ref.current) return;
    //
    //             ref.current.style.top = '98px';
    //         }
    //
    //         if (estimateNav) {
    //             if (!ref.current) return;
    //
    //             ref.current.style.top = `${88 + (TeamTrialBanner ? 42 : 0)}px`;
    //         }
    //     } else {
    //         if (TeamTrialBanner) {
    //             // @ts-ignore
    //             contentWrapper.style.paddingTop = '60px';
    //         } else {
    //             // @ts-ignore
    //             contentWrapper.style.padding = '1.5rem 1.7rem';
    //         }
    //
    //         if (estimateNav) {
    //             if (!ref.current) return;
    //
    //             ref.current.style.top = '46px';
    //         }
    //     }
    // }, [isOpen, isOpenBanner]);

    useEffect(() => {
        if (!Array.isArray(modalData)) {
            open();
        }

        const $estimateNav = $('.estimate-nav');
        const $contentWrapper = $('.content-wrapper');
        const $teamTrialBanner = $('#TeamTrialBanner');
        const hasTeamTrialBanner = $teamTrialBanner.length > 0;
        const hasEstimateNav = $estimateNav.length > 0;
        const hasModalData = Array.isArray(modalData);
        const hasBannerData = Array.isArray(bannerData);

        if (hasModalData && !hasBannerData) {
            $contentWrapper.css('paddingTop', `${60 + (hasTeamTrialBanner ? 44 : 0)}px`);

            if (ref.current) {
                if (hasEstimateNav) {
                    $(ref.current).css('top', `${88 + (hasTeamTrialBanner ? 42 : 0)}px`);
                } else if (hasTeamTrialBanner) {
                    $(ref.current).css('top', '98px');
                }
            }
        } else {
            if (hasTeamTrialBanner) {
                $contentWrapper.css('paddingTop', '60px');
            } else {
                $contentWrapper.css('padding', '1.5rem 1.7rem');
            }

            if (hasEstimateNav && ref.current) {
                $(ref.current).css('top', '46px');
            }
        }
    }, [isOpen, isOpenBanner]);

    const onCloseBanner = async () => {
        // @ts-ignore
        await closeBanner(bannerData.id);
        hideBanner();
        // @ts-ignore
        bannerData = [];
    };

    const onReadMore = () => {
        // @ts-ignore
        modalData = bannerData;
        open();
        hideBanner();
    };
    return {
        isOpenBanner,
        ref,
        onReadMore,
        onCloseBanner,
        isOpen,
        closeClientModal,
        onSendSurvey,
        t,
    };
};
